module.exports = __webpack_public_path__ + "img/reservation-active.8984c8b4.png";